import { render, staticRenderFns } from "./PaymentShipmentV2.vue?vue&type=template&id=5e6de7df"
import script from "./PaymentShipmentV2.vue?vue&type=script&lang=js"
export * from "./PaymentShipmentV2.vue?vue&type=script&lang=js"
import style0 from "./PaymentShipmentV2.vue?vue&type=style&index=0&id=5e6de7df&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports